import { useEffect, useState } from 'react'

/// Snapshot space slug (e.g. "horizon-protocol.eth") - genesis creates this off-platform at
/// snapshot.org (a real wallet signature on a third-party site, not something this codebase can
/// automate), configures its voting-power strategy to read HorizonStaking's own stake balance,
/// and sets VITE_SNAPSHOT_SPACE once that's done. Empty until then - every consumer of this hook
/// treats an empty space the same as "not configured yet" (see SNAPSHOT_NOT_CONFIGURED below),
/// the same "not deployed yet" convention every ADDRESSES.X-gated section in this app already
/// follows for on-chain contracts.
export const SNAPSHOT_SPACE = import.meta.env.VITE_SNAPSHOT_SPACE || ''
export const SNAPSHOT_NOT_CONFIGURED = !SNAPSHOT_SPACE

const SNAPSHOT_GRAPHQL = 'https://hub.snapshot.org/graphql'

/// This protocol's own voting is "vote to earn points," not real governance - see
/// StakeSection.jsx's own doc comment on GovernancePanel and scripts/indexPoints.cjs's own doc
/// comment on the points bonus this feeds. Read-only: proposal titles/status/vote counts for
/// display, plus a link out to Snapshot's own UI for actually casting a vote (that's real
/// off-chain message signing Snapshot's own app already handles correctly - not reimplemented
/// here).
export function useSnapshotProposals() {
  const [proposals, setProposals] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (SNAPSHOT_NOT_CONFIGURED) { setLoading(false); return }
    let cancelled = false

    const query = `
      query Proposals($space: String!) {
        proposals(first: 10, skip: 0, where: { space_in: [$space] }, orderBy: "created", orderDirection: desc) {
          id title state scores scores_total votes end
        }
      }
    `
    fetch(SNAPSHOT_GRAPHQL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ query, variables: { space: SNAPSHOT_SPACE } }),
    })
      .then((r) => r.json())
      .then((json) => { if (!cancelled) setProposals(json?.data?.proposals ?? []) })
      .catch((e) => { console.error('useSnapshotProposals: fetch failed', e); if (!cancelled) setProposals([]) })
      .finally(() => { if (!cancelled) setLoading(false) })

    return () => { cancelled = true }
  }, [])

  return { proposals, loading }
}
